import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d09c52c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MAtividadesComOcorrencia",
  "data-testid": "MAtividadesComOcorrencia"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "MAtividadesComOcorrencia__Icone" }, [
  /*#__PURE__*/_createElementVNode("em", {
    class: "pi pi-exclamation-triangle",
    "data-testid": "MAtividadesComOcorrencia__Icone"
  })
], -1))
const _hoisted_3 = { class: "MAtividadesComOcorrencia__Dados" }
const _hoisted_4 = {
  class: "MAtividadesComOcorrencia__DadosQuantidade",
  "data-testid": "MAtividadesComOcorrencia__DadosQuantidade"
}
const _hoisted_5 = { class: "MAtividadesComOcorrencia__DadosLegenda" }

import { usarListarEstatisticasStore } from "@/store/estatisticas/ListarEstatisticas/ListarEstatisticas.store"
  import Skeleton from "primevue/skeleton"
  import { computed } from "vue"
  import { useI18n } from "vue-i18n"

  interface Props {
    estaCarregando: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MAtividadesComOcorrencia',
  props: {
    estaCarregando: { type: Boolean }
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const estatisticasStore = usarListarEstatisticasStore()

  const quantidadeAtividadesComOcorrencias = computed(() => {
    return estatisticasStore.atividadesComOcorrencias.length
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.estaCarregando)
      ? (_openBlock(), _createBlock(_unref(Skeleton), {
          key: 0,
          class: "MAtividadesComOcorrencia__Skeleton",
          "data-testid": "MAtividadesComOcorrencia__Skeleton"
        }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(quantidadeAtividadesComOcorrencias)), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('atividadesComOcorrencias')), 1)
    ])
  ]))
}
}

})